import axios from 'axios';
import Constants from '../../constants/constants.js';

import {toast} from "react-toastify";

export function httpGet(url, config, token) {
    axios.defaults.headers.common['Authorization'] = token;
    return axios.get(url, config).catch((error) => {
        if (error.response && error.response.status === Constants.HTTP_UNAUTHORIZED) {     
            if(!url.includes("/login")) {
                window.location = process.env.REACT_APP_URL_PATH;
                return;
            }       
        }        
        if (error.response && error.response.data && error.response.data._error && error.response.data._error.message) {
            toast.error(error.response.data._error.message, {position: toast.POSITION.TOP_CENTER});
        }
    });
}

export function httpPost(url, config, token) {
    if (token !== "") {
        axios.defaults.headers.common['Authorization'] = token;
    }
    
    return axios.post(url, config).catch((error) => {
        if (error.response && error.response.status === Constants.HTTP_UNAUTHORIZED) {     
            if(!url.includes("/login")) {
                window.location = process.env.REACT_APP_URL_PATH;
                return;
            }       
        }        
        
        if (error.response && error.response.data && error.response.data._error && error.response.data._error.message) {
            toast.error(error.response.data._error.message, {position: toast.POSITION.TOP_CENTER});
        }else{
            throw error;
        }
    });
}

export function httpDelete(url, config, token) {
    if (token !== "") {
        axios.defaults.headers.common['Authorization'] = token;
    }
    
    return axios.delete(url, config).catch((error) => {
        if (error.response && error.response.status === Constants.HTTP_UNAUTHORIZED) {     
            if(!url.includes("/login")) {
                window.location = process.env.REACT_APP_URL_PATH;
                return;
            }       
        }        
        
        if (error.response && error.response.data && error.response.data._error && error.response.data._error.message) {
            toast.error(error.response.data._error.message, {position: toast.POSITION.TOP_CENTER});
        }else{
            throw error;
        }
    });
}



// WEBPACK FOOTER //
// ./src/modules/api/axios_api.js